import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './FullScreenModalLayout.st.css';
import { FullScreenModalLayoutProps } from './FullScreenModalLayout.types';
import BaseModalLayout from '../BaseModalLayout';
import FullScreenModalLayoutHeader from './components/FullScreenModalLayoutHeader';
import FullScreenModalLayoutContent from './components/FullScreenModalLayoutContent';
import FullScreenModalLayoutFooter from './components/FullScreenModalLayoutFooter';
import { DATA_HOOKS } from './FullScreenModalLayout.constants';

const FullScreenModalLayout = ({
  dataHook,
  className,
  children,
  ...restProps
}: FullScreenModalLayoutProps) => {
  return (
    <BaseModalLayout
      dataHook={dataHook || DATA_HOOKS.fullScreenModalLayoutRoot}
      className={st(classes.root, className)}
      {...restProps}
    >
      {children}
    </BaseModalLayout>
  );
};

FullScreenModalLayout.displayName = 'FullScreenModalLayout';

FullScreenModalLayout.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook: PropTypes.string,
  /**
   * Allows you to apply a CSS class to the component's root element.
   * @internal
   **/
  className: PropTypes.string,
  /** Component children - should be FullScreenModalLayout.Header, FullScreenModalLayout.Content, FullScreenModalLayout.Footer */
  children: PropTypes.node,
};

FullScreenModalLayout.Header = FullScreenModalLayoutHeader;
FullScreenModalLayout.Content = FullScreenModalLayoutContent;
FullScreenModalLayout.Footer = FullScreenModalLayoutFooter;

export default FullScreenModalLayout;
